import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'keyReadability',
    standalone: false
})
export class LicenceKeyReadablityPipe implements PipeTransform{
    transform(value: string): any {
       return (value.match(/.{1,5}/g))!.join("-");
    }
}